import { prechartBaseUrl, prechartHeaders } from "./prechart";
import type { CoverageSummary, RowCoverage } from "./widgets/coverageModel";

// Coverage card REST calls (backend `coverage_card/`). The coverage card is a
// SEPARATE record from the order card: the widget asks for it by order card
// id, and nothing here ever changes what the order card places. Every
// failure is silent — coverage is a bonus under the card, never a blocker.

export interface CoverageRow {
  index: number;
  test_name?: string | null;
  order_type?: string | null;
  kind?: string | null;
  coverage?: RowCoverage | null;
}

export interface CoverageTotal {
  billed: number;
  patient_pays: number;
  exact: boolean;
}

export interface CoverageCardData {
  enabled: boolean;
  error?: string;
  order_card_id?: string | null;
  order_card_status?: string;
  rows?: CoverageRow[];
  summary?: CoverageSummary | null;
  total?: CoverageTotal | null;
  checked_at?: string | null;
  rechecks?: number;
}

export async function fetchCoverageCard(
  threadId: string,
  cardId: string | undefined,
  opts: { force?: boolean; clientId?: number } = {},
): Promise<CoverageCardData | null> {
  try {
    const res = await fetch(`${prechartBaseUrl()}/coverage/card/`, {
      method: "POST",
      headers: prechartHeaders(opts.clientId),
      body: JSON.stringify({ thread_id: threadId, card_id: cardId ?? null, force: !!opts.force }),
    });
    if (res.status === 403) return { enabled: false };
    if (!res.ok) return null;
    return (await res.json()) as CoverageCardData;
  } catch (err) {
    console.debug("[Superdoc] coverage card fetch failed", err);
    return null;
  }
}
